<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    class="payment-select-container"
  >
    <template slot="select-header">
      {{ letter.selectPayment }}
    </template>
    <template slot="select-content">
      <ul class="payment-select-container j-payment-select-container">
        <li
          class="areas-lst select-items-popup"
          :class="{ active: price.TRANS_AMOUNT == curPrice.TRANS_AMOUNT }"
          pointClass="j-select-money"
          @click="selectPayMent(price)"
          v-for="(price, index) in pricesList"
          :key="index"
        >
          {{ changePriceFormat(price) }} {{ curPayType.show_currency }}
          <span class="get-text" style="margin: 0 5px">=</span>
          <template>
            {{ getProductName(curProduct) }}
            <template v-if="+curProduct.PRODUCT_EXTRA_COIN">
              + {{ curProduct.PRODUCT_EXTRA_COIN }}
              {{ coinName }}
            </template>
            <template v-if="+price.SUB_COIN">
              + {{ price.SUB_COIN }} {{ subCoinNama }}
            </template>
            <template v-if="+price.EXTRA_COIN">
              + {{ price.EXTRA_COIN }} {{ extraCoinName }}
            </template>
          </template>
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialTopup/selectContainer';
import { changePriceFormat } from '@utiles/officialStore';
import { mapGetters } from 'vuex';
import product from '@mixins/product';
export default {
  data() {
    return {
      totalCount: 0
    };
  },
  computed: {
    coinName() {
      return this.$store.state.coinName;
    },
    ...mapGetters(['subCoinNama', 'extraCoinName'])
  },
  props: ['pricesList', 'curPrice', 'curPayType', 'curProduct'],
  mixins: [selectContainer, product],
  methods: {
    selectPayMent(price) {
      this.$emit('selectPayMent', price);
    },
    changePriceFormat(price) {
      if (price !== undefined) {
        return changePriceFormat(price.CURRENCY, price.TRANS_AMOUNT);
      }
      return price && price.TRANS_AMOUNT;
    }
  }
};
</script>

<style scoped lang="scss">
.ico {
  width: 25px;
  margin: 0px 5px;
}
@media screen and (orientation: landscape) {
  .payment-select-container {
    ::v-deep .select-content {
      max-height: 100vh;
    }
  }
}
</style>
